var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customizer-header"},[_c('i',{staticClass:"icofont-close icon-close",on:{"click":function($event){return _vm.closecustomizer()}}}),_c('h5',{staticClass:"m-b-0"},[_vm._v(_vm._s(_vm.customizerTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }